import i18n from "@i18n/i18n";
import { Box, Snackbar } from "@mui/material";
import { observer } from "mobx-react";
import { useCallback, useState } from "react";
import AutoMappingForm from "./AutoMappingForm";
import AutoMappingGrid from "./AutoMappingGrid";

const AutoMappingPage = observer(() => {
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const [modelCommandDetail, setModelCommandDetail] = useState<any>(null);

  const handleFormSuccess = useCallback((isForEdit: boolean) => {
    setToastMessage(isForEdit ? i18n.t("auto-mapping.add-auto-mapping-dialog.edited-success") : i18n.t("auto-mapping.add-auto-mapping-dialog.created-success"));
  }, []);

  const handleDeleteSuccess = useCallback(() => {
    setToastMessage(i18n.t("auto-mapping.auto-mapping-grid.deleted-success"));
  }, []);

  const handleEditClick = useCallback((modelCommandDetail: any) => {
    setModelCommandDetail(modelCommandDetail);
  }, []);

  const handleToastClose = useCallback(() => {
    setToastMessage(null);
  }, []);

  return (
    <>
      <Box sx={{ p: 2 }}>
        {/* Auto Mapping Form */}
        <AutoMappingForm onFormSuccess={handleFormSuccess} modelCommandDetail={modelCommandDetail} clearModelCommandDetail={() => setModelCommandDetail(null)} />

        {/* Auto Mapping Grid */}
        <Box sx={{ mt: 3 }}>
          <AutoMappingGrid onDeleteSuccess={handleDeleteSuccess} onEditClick={handleEditClick} />
        </Box>

        {toastMessage && (
          <Snackbar open={!!toastMessage} autoHideDuration={2000} anchorOrigin={{ vertical: "top", horizontal: "right" }} message={toastMessage} onClose={handleToastClose} />
        )}
      </Box>
    </>
  );
});

export default AutoMappingPage;
